module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "c2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('p', {
    staticClass: "chnum"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "ct2"
    }
  }, [_vm._v("CHAPTER TWO")])]), _c('a', {
    attrs: {
      "id": "ct2"
    }
  }, [_c('p', {
    staticClass: "chtitle"
  }, [_vm._v("Long Journey to the Front")])]), _c('p', {
    staticClass: "quote"
  }, [_c('a', {
    attrs: {
      "id": "ct2"
    }
  }, [_vm._v("‘I suppose we’ll get used to all manner of sordid things in this horrible business.’ – William A. Bishop"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn1",
      "id": "c2_fnr1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Between the time Billy Bishop left the Royal Military College in Kingston, Ontario and joined the Mississauga Horse detachment, he visited Margaret Burden at her home in Toronto to explain why he needed to join the war effort. She understood that his military exercises were over and now he wanted to go overseas and – even though she could hardly imagine the horrible war that awaited him – she accepted the news bravely. ‘Of course you’re going to enlist, Billy,’ she said. ‘I would expect it of you – and I know it’s what you want to do anyway. I just pray that the war will not last too long.’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn2",
      "id": "c2_fnr2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, Billy (also called ‘Bish’) did not ship out with the Mississauga Horse."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn3",
      "id": "c2_fnr3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Due to pneumonia and an allergy that defied identification, he ended up in a military hospital. After returning to duty, in January 1915, he was transferred to the 7th Canadian Mounted Rifles, commanded by Lieutenant-Colonel Elton Ibbotson Leonard, an RMC classmate of Worth Bishop’s. Billy’s shooting and weapons maintenance skills probably led him to be placed in charge of the unit’s machine guns."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn4",
      "id": "c2_fnr4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition to his technical talents, Billy’s genial nature made him popular with 7th CMR enlisted men. George Stirrett, then a corporal in the unit, later recalled:")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("‘Bish was a nice fellow for an officer! He treated us more like buddies than subordinates ... We slept in a drafty barn and, one night, he reached into the straw and pulled out a bottle of brandy and shared it with us. He’d smuggled it out of [Col.] Leonard’s headquarters! Maybe it was because he was the youngest officer in the camp, but he was well liked by the fellows who had to take orders from him.’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn5",
      "id": "c2_fnr5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Stirrett also recalled Billy’s talent with a drum-fed Lewis machine gun:")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("‘Bish would just riddle a target that the rest of us could barely see. The instructors would keep putting it further back, until it was just a tiny black dot, and he’d shoot it to ribbons … he put every damn’ bullet on target. He never missed. I … recall the instructor shaking his head and saying, “If Bishop doesn’t kill himself in training, he’ll win the war by himself.”’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn6",
      "id": "c2_fnr6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Later the regiment was moved to London, Ontario, where all of its horses were sent out to Canadian troops already in Europe. Billy was selecting a new horse for himself, on Tuesday,\n"), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("\n6 April 1915, when he had a bad accident. While recuperating in Victoria Hospital, he described it to Margaret:")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p024_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fgtitle"
  }, [_vm._v("Lieutenant W.A. Bishop, fourth from right, with other officers of the 7th Canadian Mounted Rifles in London, Ontario, prior to sailing for England. (DHH/DND photo RE-22063)")])]), _c('p', {
    staticClass: "quote3"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("‘One of my new horses reared and fell back on me … it really is a wonder it didn’t crush me to death. It made rather a mess of my head and face, as it shoved my head right into the ground. My nose is, of course, broken and quite swollen and I can’t see out of one eye … [My] face is scraped a bit and my head [is] a series of bumps and bruises. My body is pretty well bruised, too, and I have two broken ribs. I’m all stuck up in plasters and bandages … so not very cheerful. Don’t worry, dearest, the doctor says I shall probably be able to move around by Monday [8 April].’ "), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn7",
      "id": "c2_fnr7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Much improved, the following week, Billy wrote:")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("‘This morning I … had a glorious ride. I am in charge of the equitation class now and merely ride out and instruct [the men]. Any time I feel like it I take a good little canter off by myself, and my mare is feeling fine. I talked to her all morning about you and she sends her very best love to you.’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn8",
      "id": "c2_fnr8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Billy Bishop wrote to Margaret throughout his wartime service. His letters, typed copies of which are preserved in Canada’s Directorate of History and Heritage, Department of National Defence, offer his thoughts and aspirations with a degree of candour not found in other sources. They also show the maturing effect that the course of the war had on him. He became impatient with and bored by the slow pace of events in April and May. But twenty-one-year-old Billy had little concept of the massive logistics involved as Great\n"), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("\nBritain marshalled men and matériel from throughout her empire to fight in the first truly worldwide military conflict in history.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Billy and Margaret Engaged")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Before he left Canada, Billy secured the hope of a future for him and Margaret by formally proposing to her. The event is not recorded among his letters, but their son Arthur recounted the moment as it was remembered within the family:")])]), _c('p', {
    staticClass: "quote3"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("‘She accepted him, but at the romantic moment when he should have slipped the [engagement] ring on her finger he realised in panic he had forgotten to buy a ring. Margaret was gracious about the oversight. “Your RMC ring will do for now,” she said.’ "), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn9",
      "id": "c2_fnr9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p025_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fgtitle"
  }, [_vm._v("Billy Bishop and Margaret Burden in Toronto at the time of their engagement. (DHH/DND photo RE-22064)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Finally, on 8 June, the 7th Canadian Mounted Rifles were transported from London, Ontario to Montreal to board "), _c('i', [_vm._v("SS Caledonia")]), _vm._v(", a 9,223-ton British passenger ship built in 1904 and, a decade later, converted into a troop ship to carry over 3,000 men and 200-plus horses. "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn10",
      "id": "c2_fnr10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Billy Bishop’s impressions of his first sea voyage began with mixed feelings:")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("‘As we pulled out of Montreal, crowds cheered and waved like mad. Every whistle within miles blew furiously and our men sang “God Save the King” and cheered back. It was very impressive ...’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn11",
      "id": "c2_fnr11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Just over a week later, Billy experienced a harsh reality of war. He wrote:")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("‘Three horses died during the night, making a total of eight lost so far. And we will lose a lot more during the next couple of days, as there are a lot of the poor beasts sick. They stand as long as they can, then we move away the next horse and put straw in the double stall thus made, and the poor devil lies down and usually passes away. In about fifteen minutes, overboard he goes. The ship swings sharply to avoid the carcass touching the screw and then rights itself. It is horribly cold-blooded. I often wonder what the other horses think. However, I suppose we’ll get used to all manner of sordid things in this horrible business.’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn12",
      "id": "c2_fnr12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("In England at Last")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The danger of German submarines increased as SS "), _c('i', [_vm._v("Caledonia")]), _vm._v(" drew closer to England. On\n"), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("\nthe final night of the ship’s voyage, Tuesday, 22 June, heavy fog blanketed the sea lanes approaching south-west England. After near collisions among Canadian convoy ships preparing to dock, "), _c('i', [_vm._v("Caledonia")]), _vm._v(" took a position off shore at about 4:00 am on the 23rd. Twelve hours later the ship tied up at Plymouth. That evening Billy wrote:")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('p', {
    staticClass: "quote3"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("‘The people here certainly know how to welcome you. As the ship was towed into the harbour to the naval yards, crowds formed and cheered wildly. Then, after we got on the train [to Canterbury], all through England, every person who sighted us dropped whatever they were doing to wave and cheer. It was great …’ "), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn13",
      "id": "c2_fnr13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Billy was young enough to enjoy the adulation of his early days in England, but the 7th CMR’s brief stay in Canterbury also had a sobering effect. It also provided his first look at combat aeroplanes:")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("‘Yesterday [13 July] we could hear firing all day from France and see clouds of smoke rising up. There was a big battle on and the sky was full of aeroplanes. The Channel was cleared of fishing boats … by a fleet of destroyers and last night everybody in the villages round about stayed in their houses as a Zeppelin [airship] raid was expected … I’d like to see one of the things.’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn14",
      "id": "c2_fnr14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("That was as close as Billy Bishop got to combat action. After almost two months in England, he and his comrades grew impatient with routine patrol ‘rides’ in good weather and bad. And, towards the end of July, Billy found he was not as hearty as he thought himself to be, as described in a letter from Helena Hospital in London:")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("‘Don’t be worried when you see that I am in hospital, as I came here yesterday [Saturday, 24 July] and expect to leave tomorrow or perhaps Tuesday … The chill I got on our bivouac knocked me partially out of working order and, as a tent is a poor place to get over a chill, they sent me here for a few days … It is a very nice hospital and at the present full of wounded officers. Poor chaps, a lot are being sent home for good every day.’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn15",
      "id": "c2_fnr15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Drawn to the RFC")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some two years later, writing his first memoir, Billy recalled a defining moment in his life in the summer of 1915:")]), _vm._v(" "), _c('p', {
    staticClass: "quote1"
  }, [_vm._v("‘It was the mud that made me take to flying. I had fully expected that going into battle would mean for me [to be in] the saddle of a galloping charger, instead of the snug little cock-pit of a modern aeroplane. The mud, on a certain day in … 1915, changed my whole career in the war ...")]), _vm._v(" "), _c('p', {
    staticClass: "inquote2"
  }, [_vm._v("‘[That day] I had succeeded in getting myself mired to the knees when suddenly, from somewhere out of the storm, appeared a trim little aeroplane. It landed hesitatingly in a nearby field as if scorning to brush its wings against so sordid a landscape; then [was] away again into the clean grey mists.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('p', {
    staticClass: "inquote1"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("‘How long I stood there, gazing into the distance, I do not know, but when I turned to slog my way back through the mud my mind was made up. I knew there was only one place to be on such a day – up above the clouds and in the summer sunshine. I was going into the battle that way. I was going to meet the enemy in the air.’ "), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn16",
      "id": "c2_fnr16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Billy Bishop set out to achieve this goal by looking for Royal Flying Corps officers who could tell him ‘how a man went about the business of getting away from horses, baled hay and mud – in short, how he acquired wings’. Billy’s resolve soon paid off. He wrote to Margaret during a trip to London:")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("‘Back in town again and for a reason which will surprise you very much. I got a note from an officer … on the staff of the Royal Flying Corps whom I had met [at the Grand Hotel] in Folkestone, asking me to call him at the War Office today. I had no idea what it was about, but I came hot foot, as a summons to the WO is something to make a poor subaltern tremble. Anyway … he enlightened me … [about] a vacancy in the RFC for an observing officer. (There are two kinds, pilots and observing officers.) And he offered it to me IF I can get transferred from the Canadians. I am to call him again at 12:45 and see Lord Cecil, whoever he is … and will know more then.’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn17",
      "id": "c2_fnr17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_vm._v("Billy’s appointment was with Lord Hugh Cecil, youngest son of three-term British Prime Minister Lord Robert Cecil and a well-connected Member of Parliament. The forty-six-year-old politician held a deceptive-sounding lieutenant’s commission in the RFC, but it was more like a lord lieutenant’s position. As Billy learned, one of Lord Cecil’s government duties was to be in charge of RFC aircrew recruitment. "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn18",
      "id": "c2_fnr18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_vm._v("That night, Billy wrote to Margaret:")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("‘[Lord] Cecil and he offered me a commission in the Royal Flying Corps just as soon as I can get my application through Canadian Divisional HQ. I go back to camp on Monday [9 August] and will see the colonel at once about getting my application signed … Oh, it is great luck, and to think a chance acquaintance should be of such importance to me. Incidentally, the pay in the RFC is much higher than any other branch of the service, extra pay being given for every flight you make.’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn19",
      "id": "c2_fnr19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Billy did not tell Margaret that he wanted to become a pilot and was told that it could take as long as a year to qualify. While that was too long for the man of action Billy felt himself to be, there was ‘a great need for observers’."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn20",
      "id": "c2_fnr20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" That would be a good place to start.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Billy was overjoyed when Colonel Leonard readily agreed to approve his transfer to the RFC. The future aviator dashed off a note to Margaret, seeking her moral support and endorsement for what he thought was a ‘really wonderful [opportunity] and don’t worry your pretty head, not a risky one at all. One is so seldom really up in the air and truly the casualties are very small. Oh, Darling, say you are glad that I’m doing it.’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn21",
      "id": "c2_fnr21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Zeppelins Overhead")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("On the night of 12-13 August 1915 the air war came close to Billy Bishop and the 7th Canadian Mounted Rifles when two German dirigibles – the Zeppelin-built craft L.10 and L.11 – carried out a raid along the Suffolk and Kent coastline."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn22",
      "id": "c2_fnr22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(" Billy heard airship engines and anti-aircraft fire directed at the marauders. He wrote to Margaret:")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("‘I was just sitting down to write to you last night when we got a note from dispatch riders that the Zeppelins were coming. Every light was put out and we crawled into bed in the dark. We heard the Zeppelins buzzing up in the air and a lot of explosions caused by shells fired at them, and by a few bombs they dropped, but none came within a couple of miles of us, so after a bit, off to sleep I went. This morning we [will] go out and won’t come back until tomorrow night. I hate these night manoeuvres.’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn23",
      "id": "c2_fnr23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Four nights later, the Zeppelins L.10, L.11 and L.14 carried out raids over England, with L.11 paying particular attention to Canterbury and surrounding areas."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn24",
      "id": "c2_fnr24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Billy related the effects on the ground:")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("‘About midnight there was another Zepp raid and all kinds of excitement. They bombed the ordnance stores near us and of all the unearthly rows I have ever heard, that was the worst. [We] must have had twenty guns firing at four [sic] Zepps and I don’t think they hit one, for as far as we know they got back safely to Germany. The natives around here are scared stiff … but chances of being hit by Zepps are practically nil.’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn25",
      "id": "c2_fnr25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Billy was soon distracted from the Zeppelin menace by a War Office letter requiring another RFC physical examination. The letter also indicated he would begin observer’s training soon, and possibly be posted overseas within a short time. Thinking mainly of his own route to success, Billy was overly candid when he wrote to Margaret that ‘everybody who has been to the Front says we are fools to wish we were over there. But it is our goal and we are anxious to get there.’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn26",
      "id": "c2_fnr26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Observer Training")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ten days later, on 1 September, Billy left his regiment in Kent and reported for observer training at the Netheravon flying school on Salisbury Plain. The first course was in Morse code, which neophyte observers needed to know in order to transmit messages to the ground using wireless telegraphy devices in their aeroplanes. Billy noted that the primary mission was to carry out ‘artillery observation and direct … the guns on their targets. The only answer we could receive … from the gunners was given by means of strips of cotton laid on the ground, each of which had a cryptic meaning of its own.’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn27",
      "id": "c2_fnr27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Netheravon was equipped with Avro 504 two-seat biplanes, which were ‘remembered as a delightful trainer of the war period or as a friendly aeroplane popping into and out of improbable fields’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn28",
      "id": "c2_fnr28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" later on. Used during early wartime raids over German territory, Avro 504 aircraft were fairly rugged, as Billy noted:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "quote1"
  }, [_vm._v("‘This morning we had [an Avro] machine smashed but, fortunately, no one was hurt. All morning we fooled around [at] the aerodrome but, as the weather was uncertain, only a few [students] went up. Then we all got into cars and went over to Upavon, about eight miles from here, to see a German aeroplane which had been captured. They are not as reliable machines as ours, but they are beautifully built.")])]), _c('p', {
    staticClass: "inquote"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("‘This morning a squadron also left for France. I wish I were with them. But my turn won’t take long, they tell me. I am in 21 Squadron,"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn29",
      "id": "c2_fnr29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(" A Flight, 4 Wing.’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn30",
      "id": "c2_fnr30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p029_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fgtitle"
  }, [_vm._v("Avro 504 (serial number 789) was fitted with an 80-hp Gnôme rotary engine. Billy Bishop made his first flight with 21 Squadron, RFC, in an aeroplane of this type. "), _c('i', [_vm._v("(Cross & Cockade International)")])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("First Time in the Air")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Billy wrote to Margaret about his first aviation training ‘ride’:")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("‘Last night I had a flight in an Avro, around Salisbury, Amesbury and Salisbury Plain at a height of 3,000 feet. It was glorious and I loved every minute of it. There is certainly no sport like it in the world. Rushing along [at] about eighty miles an hour, a way up so that people look like mere specks, and the only way one can detect them is by seeing a movement. It must be wonderful up about 12,000 feet.’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn31",
      "id": "c2_fnr31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Billy became so enthusiastic about the Avro 504 and was so thoroughly committed to flying that he even tempted Margaret to go up:")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("‘This morning I was up for a long flight with a chap named Robinson … from Toronto, and this afternoon I was up again, but we ran out of petrol and had a forced\n"), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("\nlanding in a grain field, and rather smashed the grain up a bit, because [it] was all stacked. Another machine flew out and brought some mechanics. We then took their machine and flew home. Honestly, Darling, it is the most wonderful invention, this flying. Someday, I shall take you up and you will love it, too.’"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn32",
      "id": "c2_fnr32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Anything to do with flying commanded Billy’s rapt attention. Especially when it concerned preparations for war:")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("‘Today, fourteen more machines left for the Front. It was a wonderful sight … to see them one after another [join] up after rushing off the ground … Then, when they had attained their [altitude], off they all flew in a long line for France, which they will reach about 4:00 this afternoon …’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn33",
      "id": "c2_fnr33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Other times, Billy was simply overjoyed to be flying:")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("‘[Today, 6 September] I had two glorious flights … with my flight-commander, an Australian named Rutledge. This is the greatest game in the world, every moment full of intense excitement. A man ceases to be human when he is way up. The earth is merely a map and you feel that to you nothing is impossible.’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn34",
      "id": "c2_fnr34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("And he was always concerned about Margaret. After several days of writing exuberantly, he became more serious and expressed his feelings for her:")]), _vm._v(" "), _c('p', {
    staticClass: "quote1"
  }, [_vm._v("‘In one of your letters you said you were afraid of the RFC. Darling Margaret, it is really no more dangerous than any other branch; for, although it may be more dangerous before we get to the Front, it is not so dangerous after we get there … [The] danger of being hit by a shell is very slight, [as] it is so hard to judge an aeroplane’s height … "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn35",
      "id": "c2_fnr35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "inquote"
  }, [_vm._v("‘I am working very hard … [as an observer]. I have to be everything from a detective to a wireless operator. I loathe the latter and, funny to say, I seem to have a talent in that line … Don’t be nervous about my flying. It is not half as dangerous as it would seem. In fact, one type of machine called the B.E.2c glides to earth automatically if anything goes wrong and [it] is as safe as a church.’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn36",
      "id": "c2_fnr36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Royal Aircraft Factory B.E.2c two-seat biplane became well known as a very stable aircraft. But, even though he had not yet flown in one, Billy was expansive in his praise of it. Perhaps he was influenced by an oft-told – and true – account that circulated at his airfield about Major (later Air Vice-Marshal Sir) Sefton Brancker, who, the previous June, flew the first B.E.2c from the factory at Farnborough to Netheravon. Brancker reported that, after climbing to 2,000 feet altitude, he ‘did not touch the controls again until he was at twenty feet on the approach to Netheravon … [and] during his flight he wrote a reconnaissance report of the country over which he flew.’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn37",
      "id": "c2_fnr37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Aerial Gunnery Training")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On Saturday, 2 October 1915, Billy moved a step closer to realising his air combat ambitions when he reported to the Duke of York School outside of Dover. With Margaret ever in his thoughts, he wrote:")]), _vm._v(" "), _c('p', {
    staticClass: "quote1"
  }, [_vm._v("‘We are being trained especially for air duels, which I hear is a great honour … I hope luck is with me, for that game is all pure luck.")])]), _c('p', {
    staticClass: "inquote"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("‘Life without you is strangely like flying between two clouds, with a burst of sunshine coming through in front, just bright enough to lead one out. You are like that to me, Darling, a light that I am making for.’ "), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn38",
      "id": "c2_fnr38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("At Dover, Billy flew almost daily when the weather was ‘at all decent’. He went out over the Channel and along the coast to Folkestone, firing a machine gun from the back seat of a training aeroplane, over the water. As he wrote to Margaret: ‘I am getting quite expert at it. I am looking forward to the first time I shall have a chance to try it with a German aeroplane for a target.’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn39",
      "id": "c2_fnr39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the end of October, Billy completed machine-gun and artillery-ranging practice and began flying over the frontlines in France. He wrote to Margaret about a flight from Dover across the Channel to St. Omer, where he and his pilot were directed to a battle zone:")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("‘We had a two-hour reconnaissance over the lines and, believe me … I am not ashamed to say it, I was glad when it was over. Then we came back here [Netheravon], landing first at Dover [to refuel]. The whole trip … took about four hours. The RFC [personnel] who are stationed in France seemed to like it there, but they dread the bad weather coming. During the winter … [there] will be a continual series of machines … going over for the day, as that way has proved [to be] so successful. [It is] so crowded in France that it is hard to find suitable places for a large number of machines.’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn40",
      "id": "c2_fnr40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After his first combat mission Billy seems to have matured quickly. He proudly told Margaret: ‘Today I was put in charge of all the observers for the 4th Wing. It is a promotion, but a rotten job, as I have to train all the new observers coming in and lecture, etc.’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn41",
      "id": "c2_fnr41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Following this initial complaint, however, he wrote: ‘I like my new work immensely and it makes a lot of time on the ground interesting, whereas it was dull before, when I wasn’t flying.’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn42",
      "id": "c2_fnr42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As he noted after one particularly successful day:")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("‘It was beautiful weather and we flew over to Lark Hill [north of Amesbury] to work with some artillery there. It is always a gamble, working with artillery … as the wireless so often doesn’t work, and there is no way of knowing it in the air. Consequently, one might send down dozens of messages and then after flying for hours, land to find that [none] … were received … Tonight the colonel"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn43",
      "id": "c2_fnr43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" told me a favourable report on my work had come from Lark Hill, so I’m quite happy.’ "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn44",
      "id": "c2_fnr44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Bishop’s First Crash")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On Wednesday, 24 November, Billy and his new pilot, a Captain Wadham, had another successful artillery-ranging exercise over Lark Hill, but experienced a mishap upon returning to Netheravon. Billy wrote:")])]), _c('p', {
    staticClass: "quote3"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("‘[While] landing we had a real live crash and “did in” the machine. Both of us got off very lightly. I got my foot bruised a bit and now have a very artistic limp, of which I am very proud. The pilot was also very lucky and got a few little bruises.’"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn45",
      "id": "c2_fnr45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Billy seems to have been none the worse for wear. Three days later he gladly accepted a ride in a new aircraft and described it to Margaret:")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("‘This morning [27 November] I had what was probably the most thrilling time of my life. I flew over to the Central Flying School [at Upavon] with one of the instructors … A new machine had just come in and had to be tested, so up we went in it. To test a machine means, of course, to put it into the hardest tests possible. We went up to 13,000 feet and dove straight down [to] 11,000 feet. When we flattened out we were going about 300 miles an hour, so you may imagine the sensation to see the earth approaching you at that rate. Then we flew up again and got the machine facing vertically upward and shut off the engine [to induce a tail-slide"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn46",
      "id": "c2_fnr46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v("]. She came down backwards about 800 feet and then he righted her again. Then he looped the loop, [and] after that he banked her up vertical and we side-slipped about 1,000 feet."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn47",
      "id": "c2_fnr47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" Then we came down [and landed]. He certainly is a wonderful pilot and the whole show created quite a sensation.’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn48",
      "id": "c2_fnr48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Unfortunately, Billy Bishop did not identify the pilot or type of aircraft that combined to provide him such an experience. Many new aircraft types passed through the Central Flying School during the war, and an educated guess as to which one arrived at Upavon on 27 November 1915 would be the Armstrong Whitworth F.K.3. Neither designer Frederick Koolhoven’s proposed improvement of the well-regarded B.E.2c nor any other World War I aircraft attained a speed of 300 mph, although ‘the F.K.3 was … faster and had a higher ceiling’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#c2_fn49",
      "id": "c2_fnr49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" than the B.E.2c. Billy had no way of knowing how high or fast the test aircraft went, but that did not prevent him from wanting to impress Margaret with his latest wartime experience.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some things never change and, for the rest of the war, Billy Bishop would seek to ‘prove’ – if only to himself – that he would be the bravest and best combatant and the worthiest man in Margaret Burden’s life.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-657b7944","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/08_c2.vue
// module id = 78
// module chunks = 0